import React from 'react'
import { Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useUser } from '@fs/zion-user'
import AgreePrivacyTermsField from './AgreePrivacyTermsField'
import ReceiveMessagesField from './ReceiveMessagesField'

export default function AgreementAndSubscriptionFields({ implicitSubscribe }) {
  const user = useUser()
  const [t] = useTranslation()

  return (
    <>
      {!user.signedIn && (
        <Row gutters="xs">
          <AgreePrivacyTermsField />
        </Row>
      )}
      {!implicitSubscribe ? (
        <Row>
          <ReceiveMessagesField />
        </Row>
      ) : (
        <Row>
          <div />
          {t(
            'conference-announce.subscribe.receive-messages',
            'I would like to receive messages from RootsTech by FamilySearch, including news about future events to the email address or mobile number I provided.'
          )}
        </Row>
      )}
    </>
  )
}
